import React from 'react'
import MetaTags from 'react-meta-tags'
// import {withExitableNav} from '../../../core/components/navbar/index'
import VisibleGrandmasterProblem from '../containers/VisibleGrandmasterProblem'
// import VisibleGrandmasterProgress from '../containers/VisibleGrandmasterProgress'
import VisibleGrandmasterSolutions from '../containers/VisibleGrandmasterSolutions'
import VisibleGrandmasterExplanations from '../containers/VisibleGrandmasterExplanations'
// import VisibleGrandmasterReason from '../containers/VisibleGrandmasterReason'
import VisibleGrandmasterOnboardingCard from '../containers/VisibleGrandmasterOnboardingCard'
// import VisibleStreakMeter from '../containers/VisibleStreakMeter'
import VisibleScoreScreen from '../containers/VisibleScoreScreen'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import ScrollToTopButton from '../../../core/components/scroll-to-top-button/ScrollToTopButton'
import Box from '../../../core/components/box/Box'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import './grandmaster.css'

class Grandmaster extends React.PureComponent {
  constructor(props) {
    super(props)
  }
  render() {
    const {className, isViewingExplanations, breadcrumbTopics, topicTitle, topicId, viewing} = this.props
    const classNames = [
      'grandmaster',
      className,
    ]
    let colorSubject = SubjectToCSSName[topicId]
    let colorSubjectId = topicId
    if (breadcrumbTopics.length) {
      colorSubject = SubjectToCSSName[breadcrumbTopics[0].id]
      colorSubjectId = breadcrumbTopics[0].id
    }
    if (colorSubject) {
      classNames.push(`grandmaster--${colorSubject}`)
    }

    const Components = !isViewingExplanations
      ? [
        {
          id: 1,
          Component: () => (
            <div>
              <VisibleGrandmasterProblem />
              <VisibleGrandmasterSolutions colorSubject={colorSubject} />
            </div>
          ),
          transitionClassName: 'gm-transition-problem'
        }
      ]
      : [
        {
          id: 2,
          Component: () => (
            <VisibleGrandmasterExplanations colorSubject={colorSubject} />
          ),
          transitionClassName: 'gm-transition-explanation'
        }
      ]

    const viewingMap = {
      'practice': (<TransitionGroup className='animated-gm'>
        {
          //Match box width, max-width props and animated-gm css
          Components.map(({id, Component, transitionClassName}) => (
            <CSSTransition classNames={transitionClassName} key={id} timeout={400}>
              <Box maxWidth='60rem' paddingTop={4} width='100%'>
                <Component />
              </Box>
            </CSSTransition>
          ))
        }
      </TransitionGroup>),
      'onboarding': <VisibleGrandmasterOnboardingCard topicName={topicTitle} subjectParent={colorSubjectId} />,
      'scores': <VisibleScoreScreen subjectColorId={colorSubjectId} />
    }
    return (
      <div className={classNames.join(' ')}>
        <MetaTags>
          <title>{`${topicTitle} - Expii Grandmaster`}</title>
        </MetaTags>
        <div className='gridcontainer'>
          <Box display='flex' justifyContent='center' position='relative'>
            {
              viewingMap[viewing]
            }
          </Box>
        </div>
        <ScrollToTopButton />
      </div>
    )
  }
}
export default Grandmaster



// WEBPACK FOOTER //
// ./src/domains/grandmaster/components/Grandmaster.js